module.exports = __webpack_public_path__ + "static/media/Skyfarm Drive, Santa Rosa, CA5.09d94577.jpg";